import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast, ToastMessage } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import desiriUserService from "../../services/desiriUser/userservice";
import desiriBullService from "../../services/desiriBull/bullservice";
import { debug } from "console";

interface Props {
  onSearch: (text: string) => void;
  onRefresh: () => void;
}

const DesiriBullsSearch: React.FC<Props> = ({ onSearch, onRefresh }) => {
  const toast = useRef<Toast>(null);
  const [searchText, setSearchText] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [MUOptions, setMUOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [pairBullOptions, setPairBullOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    posID: null,
    bullNumber: "",
    name: "",
    dob: null as Date | null,
    age: null as number | null,
    gender: "",
    breed: "",
    color: "",

    weightKG: 0 as number | null,
    isForBreeding: false,
    pairOfTheBull: null as number | null,
  });

  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ];

  const handleInputChange = (field: string, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage["severity"]
  ) => {
    toast.current?.show({
      severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };

  const handleSearch = () => onSearch(searchText.trim());

  const resetFields = () => {
    setSearchText("");
    onSearch("");
  };

  const handleSave = async () => {
    const newErrors: { [key: string]: string } = {};

    // Validation
    if (!formData.bullNumber?.trim())
      newErrors.bullNumber = "Bull Number is required";
    if (!formData.name?.trim()) newErrors.name = "Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!formData.age) newErrors.age = "Age is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.weightKG) newErrors.weightKG = "Weight (KG) is required";
    if (!formData.posID) newErrors.posID = "Manufacturing Unit is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }debugger
    const payload = {
      
      posID: formData.posID,
      bullNumber: formData.bullNumber?.trim(),
      name: formData.name?.trim(),
      dob: formData.dob
        ? new Date(formData.dob).toLocaleDateString("en-CA")
        : null,
      age: formData.age,
      gender: formData.gender,
      breed: formData.breed || null,
      color: formData.color || null,
      weightKG: formData.weightKG,
      isForBreeding: formData.isForBreeding ?? false,
      pairOFthebull: formData.pairOfTheBull || null,
    };

  try {
      const result = await desiriBullService.addBull(payload);

      if (result?.isSuccess) {
        showMessage(
          "Success",
          result?.message || "Bull added successfully",
          "success"
        );
        resetForm();
        setShowAddModal(false);
        onRefresh();
      } else {
        showMessage("Failed", result?.message || "Failed to add bull", "error");
      }
    } catch (error) {
      console.error("Error saving bull:", error);
      showMessage("Error", "Error while saving bull", "error");
    }
  };

  const resetForm = () => {
    setFormData({
      posID: null,
      bullNumber: "",
      name: "",
      dob: null,
      age: null,
      gender: "",
      breed: "",
      color: "",
      weightKG: 0,
      isForBreeding: false,
      pairOfTheBull: null,
    });
    setErrors({});
  };

  const aliasMU = (id: number, name?: string) => {
    if (id === 3) return "Unit-1-KR";   // K R Nagar
    if (id === 4) return "Unit-2-MT";   // Magadi Taluk
    const up = (name ?? "").toUpperCase().replace(/\s+/g, " ").trim();
    if (/\bK\s*R\s*NAGAR\b/.test(up) || up.includes("KR NAGAR")) return "Unit-1-KR";
    if (up.includes("MAGADI TALUK") || up.includes("MAGADI")) return "Unit-2-MT";
    return name ?? "";
  };

  useEffect(() => {
    const fetchMUPlants = async () => {
      try {
        const response = await desiriUserService.getAllMUPlants();
        // ONLY CHANGE: map to alias label and normalize IDs
        const formatted = (response ?? []).map((d: any) => {
          const id = Number(d?.posID ?? d?.PosID ?? d?.id);
          const name = d?.posName ?? d?.PosName ?? d?.address2 ?? d?.Address2 ?? "";
          return {
            label: aliasMU(id, name), // show Unit-1-KR / Unit-2-MT
            value: id,
          };
        });
        setMUOptions(formatted);
      } catch (error) {
        console.error("Failed to load Manufacturing Units:", error);
      }
    };

    fetchMUPlants();
  }, []);

  useEffect(() => {
    const fetchPairBulls = async () => {
      try {
        const data = await desiriBullService.getAllBullsForPairing();
        setPairBullOptions(data);
      } catch (err) {
        console.error("Failed to load bulls for pairing", err);
      }
    };

    fetchPairBulls();
  }, []);
  const fieldHoverStyle = (fieldName: string) => ({
    border:
      hoveredField === fieldName ? "2px solid #6366F1" : "1px solid #ced4da",

    boxShadow:
      hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
  });
  const handleDialogClose = () => {
    resetForm();
    setShowAddModal(false);
  };

  return (
    <div className="col-12">
      <Toast ref={toast} />

      {/* Search & Action Bar */}
      <div className="card border-noround p-2" style={{ minHeight: "3.5rem" }}>
        <div
          className="input-container font-bold text-white border-round"
          style={{ float: "left", width: "18%" }}
        >
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Keyword Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="buttons-container">
          <div
            className="filter-button font-bold text-white border-round"
            style={{ float: "left", width: "10%" }}
          >
            <Button
              className="text-black border-round"
              style={{ width: "100%" }}
              onClick={handleSearch}
              severity="success"
            >
              Filter
            </Button>
          </div>
          <div
            className="filter-button font-bold text-white border-round ml-2"
            style={{ float: "left", width: "10%" }}
          >
            <Button
              className="text-black border-round"
              style={{ width: "100%" }}
              onClick={resetFields}
              severity="secondary"
              text
              raised
            >
              Reset
            </Button>
          </div>
          <div
            className="add-button-container border-round font-bold ml-3 text-primary"
            style={{ textAlign: "right" }}
          >
            <Button
              className="bg-blue-700 border-round p-button p-button-text p-component text-white"
              onClick={() => setShowAddModal(true)}
              severity="secondary"
              text
              raised
            >
              Add Bull
            </Button>
          </div>
        </div>
      </div>

      {/* Add Bull Modal */}
      <Dialog
        visible={showAddModal}
        onHide={handleDialogClose}
        className="quickview w-50"
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        modal
      >
        <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
          ADD DESIRI BULL
        </h5>

        <div className="grid">
          <div className="col-12 mb-2">
            <div className="grid">
              {/* Manufacturing Unit */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Manufacturing Unit<span className="required">*</span>
                </label>
                <Dropdown
                  value={formData.posID}
                  options={MUOptions}
                  onChange={(e) => {
                    setFormData({ ...formData, posID: e.value });

                    if (errors.posID) {
                      setErrors({ ...errors, posID: "" });
                    }
                  }}
                  placeholder="Select Manufacturing Unit"
                  style={fieldHoverStyle("description")}
                />
                {errors.posID && (
                  <small className="p-error">{errors.posID}</small>
                )}
              </div>

              {/* Bull Number */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Bull Number<span className="required">*</span>
                </label>
                <InputText
                  value={formData.bullNumber}
                  onChange={(e) =>
                    handleInputChange("bullNumber", e.target.value)
                  }
                  placeholder="Enter Bull Number"
                  style={fieldHoverStyle("description")}
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.bullNumber && (
                  <small className="p-error">{errors.bullNumber}</small>
                )}
              </div>

              {/* Name */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Name<span className="required">*</span>
                </label>
                <InputText
                  value={formData.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  placeholder="Enter Name"
                  style={fieldHoverStyle("description")}
                  onKeyPress={(e) => {
                    if (!/[a-zA-Z]/.test(e.key) || formData.name.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.name && (
                  <small className="p-error">{errors.name}</small>
                )}
              </div>

              {/* Gender */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Gender<span className="required">*</span>
                </label>
                <Dropdown
                  value={formData.gender}
                  options={genderOptions}
                  onChange={(e) => {
                    setFormData({ ...formData, gender: e.value });

                    if (errors.gender) {
                      setErrors({ ...errors, gender: "" });
                    }
                  }}
                  placeholder="Select Gender"
                  style={fieldHoverStyle("description")}
                />
                {errors.gender && (
                  <small className="p-error">{errors.gender}</small>
                )}
              </div>

              {/* DOB */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Date of Birth<span className="required">*</span>
                </label>
                <Calendar
                  value={formData.dob}
                  onChange={(e) => {
                    handleInputChange("dob", e.value);
                  }}
                  dateFormat="dd-mm-yy"
                  style={fieldHoverStyle("description")}
                  placeholder="Select DOB"
                />
                {errors.dob && <small className="p-error">{errors.dob}</small>}
              </div>

              {/* Age */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Age<span className="required">*</span>
                </label>
                <InputNumber
                  value={formData.age}
                  onValueChange={(e) =>
                    handleInputChange("age", e.value ?? null)
                  }
                  style={fieldHoverStyle("description")}
                  placeholder="Enter Age"
                  useGrouping={false}
                  min={0}
                  max={99}
                  maxLength={2}
                  onKeyPress={(e) => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.age && <small className="p-error">{errors.age}</small>}
              </div>

              {/* Breed */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">Breed</label>
                <InputText
                  value={formData.breed}
                  onChange={(e) =>
                    setFormData({ ...formData, breed: e.target.value })
                  }
                  placeholder="Enter Breed"
                  style={fieldHoverStyle("description")}
                  onKeyPress={(e) => {
                    if (
                      !/[a-zA-Z]/.test(e.key) ||
                      formData.breed.length >= 10
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              {/* Color */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">Color</label>
                <InputText
                  value={formData.color}
                  onChange={(e) =>
                    setFormData({ ...formData, color: e.target.value })
                  }
                  placeholder="Enter Color"
                  style={fieldHoverStyle("description")}
                  onKeyPress={(e) => {
                    if (
                      !/[a-zA-Z]/.test(e.key) ||
                      formData.color.length >= 10
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              {/* Weight */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Weight (KG)<span className="required">*</span>
                </label>
                <InputNumber
                  value={formData.weightKG}
                  onValueChange={(e) =>
                    handleInputChange("weightKG", e.value ?? null)
                  }
                  placeholder="Enter Weight"
                  style={fieldHoverStyle("description")}
                  useGrouping={false}
                  maxLength={3}
                  onKeyPress={(e) => {
                    const currentValue = formData.weightKG?.toString() || "";
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.weightKG && (
                  <small className="p-error">{errors.weightKG}</small>
                )}
              </div>

              {/* For Breeding */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  For Breeding?<span className="required">*</span>
                </label>
                <Dropdown
                  value={formData.isForBreeding}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                  onChange={(e) =>
                    setFormData({ ...formData, isForBreeding: e.value })
                  }
                  placeholder="Select Option"
                  style={fieldHoverStyle("description")}
                />
              </div>

              {/* Pair of the Bull */}
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">Pair of the Bull</label>
                <Dropdown
                  value={formData.pairOfTheBull}
                  options={pairBullOptions}
                  onChange={(e) =>
                    setFormData({ ...formData, pairOfTheBull: e.value })
                  }
                  placeholder="Select Pair Bull"
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className="field col-12 md:col-6 text-right  mt-5">
                <Button
                  className="bg-green-700 text-white p-button p-button-text p-component"
                  onClick={handleSave}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DesiriBullsSearch;